import React, { useEffect } from "react";

import "./Loader.scss";
import { startLoader, stopLoader } from "../../utils/loaderUtils";

const Loader = () => {
  useEffect(() => {
    if (window.ReactNativeWebView) {
      startLoader();
    }
    return () => {
      stopLoader();
    };
  }, []);

  if (window.ReactNativeWebView) {
    return null;
  }
  return (
    <div className="loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
